import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PropertyCalendarReferrerService {
  constructor() {}

  private _lastReferrer: BehaviorSubject<string> = new BehaviorSubject('details');
  public lastReferrer$: Observable<string> = this._lastReferrer.asObservable();

  public setReferrer(referrer: string) {
    this._lastReferrer.next(referrer);
  }
}
